import React from 'react';
import T from 'prop-types';
import { Modal as AntdModal } from 'antd';

class Modal extends React.PureComponent {
  handleCancel = () => {
    this.props.updateQueryString({
      modal: undefined,
    });
    this.props.onCancel();
  };

  render() {
    const { children, isVisible, ...props } = this.props;

    return (
      <AntdModal {...props} destroyOnClose keyboard onCancel={this.handleCancel} visible={isVisible}>
        {children}
      </AntdModal>
    );
  }
}

Modal.propTypes = {
  updateQueryString: T.func.isRequired,
  onCancel: T.func,

  isVisible: T.bool.isRequired,
  children: T.node.isRequired,
};

Modal.defaultProps = {
  onCancel: () => {},
};

export default Modal;
